export default __webpack_public_path__ + "static/media/renew-code--mobile@2x.7518b914.jpg";